export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/rushing-icon.svg?a6fc9c460d0598538acdfd6a3f03db1f";